import request from '../utils/request'

//获取任务类型列表
export function getTaskTypes(query) {
  return request({
    url: '/diagtasks/gettasktype',
    method: 'get',
    params: query
  })
}

//获取任务状态列表
export function getTaskStatus(query) {
  return request({
    url: '/diagtasks/gettaskstatus',
    method: 'get',
    params: query
  })
}

//获取任务设备列表
export function getTaskDevices(query) {
  return request({
    url: '/diagtasks/gettaskdevices?Page=1&Size=100000000',
    method: 'get',
    params: query
  })
}

//通讯协议类型
export function getCommunication(query) {
  return request({
    url: '/diagtasks/getcommunication',
    method: 'get',
    params: query
  })
}

//CAN Passthru的类型列表
export function getDiccanpassthruType(query) {
  return request({
    url: '/diagtasks/getdiccanpassthrutype',
    method: 'get',
    params: query
  })
}

//CAN硬件类型列表
export function getDiccandevicesType(query) {
  return request({
    url: '/diagtasks/getdiccandevicestype',
    method: 'get',
    params: query
  })
}

//测量项列表查询
export function getDicdiagudsmeasureddataType(query) {
  return request({
    url: '/diagtasks/getdicdiagudsmeasureddatatype',
    method: 'get',
    params: query
  })
}

//获取任务列表
export function getTasks(query) {
  return request({
    url: '/diagtasks/getdevicetasks',
    method: 'get',
    params: query
  })
}

//获取任务详情
export function getTask(id) {
  return request({
    url: '/diagtasks/gettask/'+id,
    method: 'get'
  })
}

//添加任务
export function addTask(data) {
  return request({
    url: '/diagtasks/diagtasks',
    method: 'post',
    data
  })
}

//修改任务
export function editTask(id, data) {
  return request({
    url: '/diagtasks/diagtask/'+id,
    method: 'put',
    data
  })
}

//开始任务
export function startTask(id) {
  return request({
    url: '/diagtasks/starttask/'+id,
    method: 'post',
  })
}

//结束任务
export function stopTask(id) {
  return request({
    url: '/diagtasks/stoptask/'+id,
    method: 'post',
  })
}

//删除任务
export function delTasks(ids) {
  return request({
    url: '/diagtasks/deletetask/'+ids,
    method: 'delete',
  })
}

//重置任务
export function resetTask(id, data) {
  return request({
    url: '/diagtasks/resendtask/'+id,
    method: 'post',
	data
  })
}

